import { z } from 'zod';
import { TMDXFile } from '@/api/apis/files';
import { getPhoneSchema } from '@/utils/helpers';

export const CONTACT_FORM_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  primaryPhone: '',
  secondaryPhone: '',
};

export const contactSchema = z.object({
  firstName: z
    .string()
    .min(1, 'Provide first name')
    .refine((value) => value.trim().length > 0, { error: 'First name cannot be empty or whitespace' }),
  lastName: z
    .string()
    .min(1, 'Provide last name')
    .refine((value) => value.trim().length > 0, { error: 'Last name cannot be empty or whitespace' }),
  photo: z.custom<TMDXFile>().optional(),
  photoPath: z.string().optional(),
  email: z.union([z.literal(''), z.email({ error: 'Invalid email' }), z.null()]),
  primaryPhone: getPhoneSchema({ isRequired: true }),
  secondaryPhone: getPhoneSchema({ isRequired: false }),
});
